import React, { Component } from "react";
import { Link } from "react-router-dom";
import _ from "lodash";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons'

let getFieldType = (schema, uiSchema) => {
  let fieldType = "text";

  if (schema.type === "string") {
    fieldType = "text";
  } else if (schema.type === "number") {
    fieldType = "number";
  } else if (schema.type === "boolean") {
    fieldType = "checkbox";
  }
  if ("enum" in schema) {
    fieldType = "select";
  }
  if ("ui:widget" in uiSchema && uiSchema["ui:widget"] !== "") {
    fieldType = uiSchema["ui:widget"];
  }
  if (schema.type === "array" && "items" in schema) {
    fieldType = "repeater";
  }
  if (
    schema.type === "array" &&
    "items" in schema &&
    uiSchema["ui:widget"] === "table"
  ) {
    fieldType = "table";
  }

  return fieldType;
};

class FieldPreview extends Component {
  renderValue({
    errors,
    fieldType,
    id,
    pageNum,
    schema,
    application,
    uiSchema,
    value,
    filename
  }) {
    let displayValue = [];
    if (fieldType === "file" && value) {
      let url = document.createElement("a");
      url.href = value;
      filename = url.pathname.substring(url.pathname.indexOf("-upload-") + 8);
      // display File Uploads
      displayValue = [
        <p key={`value.${id}`}>
          <a href={value} target="_blank">
            {filename}
          </a>
        </p>
      ];
    } else if (fieldType === "radio") {
      // display Radio button values
      displayValue =
        "enumNames" in schema
          ? [schema.enumNames[schema.enum.indexOf(value)]]
          : [value];
    } else if (fieldType === "checkboxes" && typeof value === "object") {
      // display Checkbox values
      displayValue = [
        <p key={`value.${id}`}>
          {value.map(val => {
            return (
              <span key={val} className="preview-checked">
                <FontAwesomeIcon
                  ariaLabel="checked"
                  icon={faCheckSquare}
                  className="text-muted"
                />
                &nbsp;
                {"enumNames" in schema
                  ? schema.enumNames[schema.enum.indexOf(val)]
                  : val}
              </span>
            );
          })}
        </p>
      ];
    } else if (Array.isArray(value) && value.length > 0) {
      displayValue = value.map((val, i) => {
        // display Repeater or other array values

        let arrayDisplayValues = [];

        if (i > 0) {
          arrayDisplayValues.push(<hr key="hr" />);
        }

        uiSchema.items["ui:order"].map(sub_id => {
          let itemDisplayValues = [];

          let sub_val = val[sub_id.substring(sub_id.indexOf(".") + 1)];

          let currentSchema = schema.items.properties[`${sub_id}`];
          let currentUiSchema = uiSchema.items[sub_id];
          let labelClass = "";
          let groupClass = "form-group";
          let newProps = {
            application: application,
            id: sub_id.replace(".", `[${i}].`),
            value: sub_val,
            fieldType: getFieldType(currentSchema, currentUiSchema),
            slug: application.slug,
            errors: errors,
            pageNum: pageNum
          };

          // console.log(currentSchema, currentUiSchema);

          if ("ui:widget" in currentUiSchema) {
            groupClass = `${groupClass} widget-${currentUiSchema["ui:widget"]}`;
          }

          if (
            "ui:options" in currentUiSchema &&
            "labelClass" in currentUiSchema["ui:options"]
          ) {
            labelClass = `${labelClass} ${uiSchema["ui:options"].labelClass}`;
          }

          itemDisplayValues.push([
            <label key={`${sub_id}_label`} className={labelClass}>
              {currentSchema.title}
            </label>
          ]);

          if (currentUiSchema["ui:widget"] !== "hidden") {
            itemDisplayValues.push(
              <div className="previewValue" key={`${sub_id}_value`}>
                {this.renderValue(newProps)}
              </div>
            );
          }

          arrayDisplayValues.push(
            <div className={groupClass} key={`${sub_id}_group`}>
              {itemDisplayValues}
            </div>
          );

          return true;
        });

        return (
          <div className="form-group" key={`${id}.${i}`}>
            {arrayDisplayValues}
          </div>
        );
      });
    } else if (value === 0) {
      displayValue = [<p key={`value.${id}`}>0</p>];
    } else if (
      !_.isUndefined(value) &&
      !_.isNull(value) &&
      !_.isNaN(value) &&
      value !== ""
    ) {
      // display generic values
      displayValue = [<p key={`value.${id}`}>{value}</p>];
    } else if (fieldType !== "hidden") {
      displayValue = [
        <p key={`value.${id}`} className="empty">
          None
        </p>
      ];
    }

    // console.log("error check", id, errors);

    if (id in errors) {
      // console.log("ERROR", id);
      displayValue.push(
        <p key={`error[${id}]`}>
          <Link
            className="badge badge-danger"
            aria-describedby={id}
            to={`/${application.slug}/form/${pageNum}#${id}`}
          >
            {errors[id]}
          </Link>{" "}
          <small>
            <Link
              className="text-"
              aria-describedby={id + "_label"}
              to={`/${application.slug}/form/${pageNum}#${id}`}
            >
              Edit response
            </Link>
          </small>
        </p>
      );
    }

    return displayValue;
  }

  render() {
    let renderValue = this.renderValue(this.props);

    return <div className="previewValue">{renderValue}</div>;
  }
}

export default FieldPreview;



// WEBPACK FOOTER //
// ./src/FieldPreview.js